const vegetable=[

  {
		"name":"Cabbage",
		"images":"https://www.freepngimg.com/thumb/categories/2970.png",
		"quantity":"One Unit",
		"id":2,
		"price": 30,
        "type":"vegetable"
	},
	{
		"name":"Capsicum",
		"images":"https://www.nicepng.com/png/detail/52-525615_green-bell-pepper-png-green-capsicum-png.png",
		"quantity":"One Unit",
		"id":7,
		"price": 5,
        "type":"vegetable"
	},
	{
		"name":"Garlic",
		"images":"https://www.freepngimg.com/thumb/garlic/2-2-garlic-transparent-thumb.png",
		"quantity":"One Unit",
		"id":10,
		"price": 20,
        "type":"vegetable"
	},
	{
		"name":"Beetroot",
		"images":"https://pngimg.com/uploads/beet/beet_PNG28.png",
		"quantity":"One Unit",
		"id":11,
		"price": 20,
        "type":"vegetable"
	},
	{
		"name":"Tomatoes",
		"images":"https://www.freepngimg.com/thumb/categories/2985.png",
		"quantity":"One Unit",
		"id":13,
		"price": 5,
        "type":"vegetable"
	},
	{
		"name":"Celeriac",
		"images":"https://w7.pngwing.com/pngs/252/146/png-transparent-celeriac-leaf-vegetable-food-celery-herbes-leaf-vegetable-food-plant-stem-thumbnail.png",
		"quantity":"One Bunch",
		"id":16,
		"price": 5,
        "type":"vegetable"
	},
	{
		"name":"Carrots",
		"images":"https://www.freepngimg.com/thumb/categories/2971.png",
		"quantity":"One Kg",
		"id":18,
		"price": 60,
        "type":"vegetable"
	},
	{
		"name":"Onions",
		"images":"https://www.freepngimg.com/thumb/onion/10-red-onion-png-image-thumb.png",
		"quantity":"One Kg",
		"id":19,
		"price": 120,
        "type":"vegetable"
	},
	{
		"name":"Potatoes",
		"images":"https://www.freepngimg.com/thumb/potato/7-potato-png-images-pictures-download-thumb.png",
		"quantity":"One container",
		"id":20,
		"price": 80,
        "type":"vegetable"
	}
]

export default vegetable
